import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../BinTransfer/BinTransferMain.css";
import { ArrowForwardIos } from "@mui/icons-material";
import { useSelector } from "react-redux";
import Grid from "@mui/material/Grid";
function Notification_Breadcrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;

  return (
    <div className="notification-breadcrumb">
      {vPathName === "/Notification" ? (
        <div>
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            Notification{" "}
          </span>
        </div>
      ) : vPathName === "/PickingHead" ? (
        <div className="d-flex align-items-center">
          <Link
            to="/Notification"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
            Notification
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "5px" }} />
          <div>
            <span
              className="breadcrumb-not-active"
              //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
            >
              PickingHead{" "}
            </span>
          </div>
        </div>
      ) : vPathName === "/PickingPendingList" ? (
        <>
          <Grid
            container
            spacing={0}
            columns={{ xs: 2, sm: 3, md: 12, lg: 12 }}
          >
            <Grid item xs={0.8} md={1.5} lg={1}>
              <Link
                to="/Notification"
                state={{
                  ...location.state,
                  current: "PickingPendingList",
                }}
                // style={{ fontSize: '1rem', marginRight: '1rem' }}
                className={"breadcrumb-active mr-2"}
              >
                Notification
              </Link>
            </Grid>
            <Grid item xs={0.2} md={0.2} lg={0.2}>
              <ArrowForwardIos color="info" style={{ marginRight: "10px" }} />
            </Grid>
            <Grid item xs={0.8} md={2.4} lg={1.6}>
              <span
                className="breadcrumb-not-active"
                //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
              >
                PickingPendingList
              </span>
            </Grid>
          </Grid>
        </>
      ) : vPathName === "/PickingDetail" ? (
        <>
          <Grid
            container
            spacing={0}
            columns={{ xs: 2, sm: 3, md: 12, lg: 12 }}
          >
            <Grid item xs={0.8} md={1.5} lg={1}>
              <Link
                to="/Notification"
                state={location.state}
                // style={{ fontSize: '1rem', marginRight: '1rem' }}
                className={"breadcrumb-active mr-2"}
              >
                Notification
              </Link>
            </Grid>
            <Grid item xs={0.2} md={0.2} lg={0.2}>
              <ArrowForwardIos color="info" style={{ marginRight: "10px" }} />
            </Grid>
            <Grid item xs={1} md={2.6} lg={1.6} className="col-5 col-md-3">
              <Link
                to="/PickingPendingList"
                state={{
                  ...location.state,
                  current: "PickingPendingList",
                }}
                // style={{ fontSize: '1rem', marginRight: '1rem' }}
                className={"breadcrumb-active mr-2"}
              >
                PickingPendingList
              </Link>
            </Grid>
            <Grid
              item
              xs={0.2}
              md={0.2}
              lg={0.2}
              // className={
              //   vRdxDetailObj.A_Typ == "A"
              //     ? "col-1 col-md-1"
              //     : "hide_BreadCrumbs"
              // }
              // className={
              //   vRdxDetailObj.A_Typ == "A"
              //     ? "col-1 col-md-1"
              //     : "hide_BreadCrumbs"
              // }
              className="col-1 col-md-1"
            >
              <ArrowForwardIos color="info" style={{ marginRight: "10px" }} />
            </Grid>
            <Grid item xs={0.8} md={1.6} lg={1.2}>
              <span
                className="breadcrumb-not-active"
                //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
              >
                PickingDetail{" "}
              </span>
            </Grid>
          </Grid>
        </>
      ) : (
        <></>
      )}
    </div>
  );
}
export default Notification_Breadcrumbs;
